import React from "react";
import { Link, NavLink, Outlet } from "react-router-dom";
import { useI18n } from "@/lib/i18n";
import { tk } from "@/i18n";
import { useAuth } from "@/context/AuthContext";
import { Logo, LangToggle, ThemeToggle } from "@/components/common";
import { Button } from "@/components/ui/button";

const LINKS = [["nav_features", "/features", tk("Features")], ["nav_ai", "/ai-search", tk("AI Search")], ["nav_recruiters", "/recruiters", tk("Recruiters")],
  ["nav_candidates", "/candidates", tk("Candidates")], ["nav_pricing", "/pricing", tk("Pricing")], ["nav_contact", "/contact", tk("Contact")]];

export default function PublicLayout() {
  const { t } = useI18n();
  const { user } = useAuth();
  const home = user ? (user.account_type === "candidate" ? "/me" : "/app") : null;
  return (
    <div className="min-h-screen flex flex-col">
      <header className="sticky top-0 z-40 border-b bg-background/75 backdrop-blur-xl">
        <div className="max-w-7xl mx-auto h-16 px-5 flex items-center gap-3 sm:gap-6">
          <Logo />
          <nav className="hidden md:flex items-center gap-1">
            {LINKS.map(([k, to, label]) => (
              <NavLink key={k} to={to} data-testid={`public-nav-${k}`}
                className={({ isActive }) => `px-3 py-1.5 rounded-md text-[13px] font-medium transition-colors ${isActive ? "text-foreground" : "text-muted-foreground hover:text-foreground"}`}>{t(label)}</NavLink>
            ))}
          </nav>
          <div className="flex-1" />
          <LangToggle /><ThemeToggle />
          {home ? <Button asChild size="sm" data-testid="go-to-app"><Link to={home}>{t("Open app")}</Link></Button> : (
            <>
              <Link to="/login" className="whitespace-nowrap text-[13px] font-medium text-muted-foreground hover:text-foreground" data-testid="header-login">{t("Log in")}</Link>
              <Button asChild size="sm" className="rounded-full hidden sm:inline-flex" data-testid="header-register"><Link to="/register">{t("Start free trial")}</Link></Button>
            </>
          )}
        </div>
      </header>
      <main className="flex-1"><Outlet /></main>
      <footer className="border-t mt-24">
        <div className="max-w-7xl mx-auto px-5 py-10 grid sm:grid-cols-4 gap-8 text-sm">
          <div className="sm:col-span-2"><Logo /><p className="text-muted-foreground mt-3 max-w-sm">{t("Hire at the speed of AI.")}</p></div>
          <div className="space-y-2 text-muted-foreground">
            <Link to="/pricing" className="block hover:text-foreground">{t("Pricing")}</Link>
            <Link to="/candidates" className="block hover:text-foreground">{t("Candidates")}</Link>
            <Link to="/contact" className="block hover:text-foreground">{t("Contact")}</Link>
          </div>
          <div className="space-y-2 text-muted-foreground">
            <Link to="/privacy" className="block hover:text-foreground" data-testid="footer-privacy">{t("Privacy Policy")}</Link>
            <Link to="/terms" className="block hover:text-foreground" data-testid="footer-terms">{t("Terms of Service")}</Link>
          </div>
        </div>
        <div className="max-w-7xl mx-auto px-5 pb-8 text-xs text-muted-foreground">© 2026 TOPTALENT.IO</div>{/* i18n-ignore */}
      </footer>
    </div>
  );
}
